import SettingsController from 'webapp/controllers/genie/settings';

export default class MobileSettingsController extends SettingsController {}
